<template>
    <div class="invite-container">
        <el-card shadow="hover" class="invite-card" v-loading="loading">
            <div class="header">
                <el-avatar :size="80" v-if="teacher.avatar" :src="$host + teacher.avatar"></el-avatar>
                <h2 class="margin-t">{{ $t('班级加入邀请') }}</h2>
            </div>

            <el-divider></el-divider>

            <div class="info-item">
                <span class="label">{{ $t('邀请老师') }}：</span>
                <span class="value">{{ teacher.name }}</span>
            </div>
            <div class="info-item">
                <span class="label">班级名称：</span>
                <span class="value">{{ clazz.name }}</span>
            </div>
            <div class="info-item">
                <span class="label">班级编号：</span>
                <span class="value">{{ clazz.code }}</span>
            </div>

            <div class="info-item">
                <span class="label">创建时间：</span>
                <span class="value">{{ clazz.created_at }}</span>
            </div>

            <div class="info-item">
                <span class="label">邀请说明：</span>
                <span class="value">欢迎加入本班，请确认是否接受邀请</span>
            </div>
            <div class="info-item">
                <span class="label">加入状态：</span>
                <span class="value">{{ status ? $t('已加入') : $t('未加入') }}</span>
            </div>

            <el-divider></el-divider>

            <div class="btn-group">

                <el-button v-if="status" type="primary" icon="el-icon-back" size="medium"  @click="back()">
                    {{ $t('返回首页') }}
                </el-button>

                <el-button type="primary" v-else icon="el-icon-check" size="medium" 
                    @click="handleAccept">
                    接受邀请
                </el-button>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "ClassInviteConfirm",
    data() {
        return {
            acceptLoading: false,
            refuseLoading: false,
            dialogVisible: false,
            dialogText: "",
            actionType: "", // accept / refuse
            clazz: {},
            teacher: {},
            status: false,
            loading: false
        };
    },

    created() {
        this.loading = true
        this.$http.post('/api/class/info', { code: this.$route.query.code, teacher_id: this.$route.query.teacher }).then((res) => {
            this.clazz = res.clazz
            this.teacher = res.teacher
            this.status = res.status
            this.loading = false
        })
    },
    methods: {
        // 接受邀请
        handleAccept() {
            this.$confirm('', this.$t('确认加入班级') + '?', {
                showCancle: false,
                center: true,
                confirmButtonClass: "confirm-btn",
                confirmButtonText: this.$t('确定'),
                cancelButtonText: this.$t('取消'),
                type: 'primary'
            }).then(() => {
                this.$http.post("/api/class/student", { clazz_id: this.clazz.id }).then(() => {
                    this.$message({
                        type: 'success',
                        message: this.$t('加入成功')
                    });
                })
            }).catch(() => {

            });
        },
        // 拒绝邀请
        back() {
            this.$router.replace('/main')
        },
        
    }
};
</script>

<style scoped>
.invite-container {
    min-height: 70vh;
    background-color: #f5f7fa;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
}

.invite-card {
    width: 70%;
}

.header {
    text-align: center;
}

.invite-icon {
    font-size: 48px;
    color: #e6a13c;
}

.info-item {
    display: flex;
    padding: 10px 0;
    font-size: 15px;
}

.label {
    font-weight: 600;
    width: 100px;
}



.btn-group {
    display: flex;
    gap: 16px;
    justify-content: center;
    margin-top: 10px;
}
</style>
